import {
  ICalculateObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  CalculateItem,
} from "../../../../domain/document/items";
import {
  CalculateKinds,
} from "../../../../domain/document";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";

export class CalculateObjectStyleReader extends AbstractTextObjectStyleReader<CalculateItem> {
  constructor(private readonly _configuration: ICalculateObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: CalculateItem, shouldInputFree: boolean): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: CalculateItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: CalculateItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: CalculateItem, shouldInputFree: boolean): IObjectColorConfiguration {
    return (source.shouldInputFree || (source.isFreeInputable && shouldInputFree))
      ? this._configuration.default
      : this.readObjectStyleConfigurationByKind(source.calculateKind);
  }
  
  private readObjectStyleConfigurationByKind(kind: CalculateKinds): IObjectColorConfiguration {
    switch (kind) {
      case CalculateKinds.Calculate:
        return this._configuration.calculation;
      case CalculateKinds.CompareDate:
        return this._configuration.dateComparison;
      case CalculateKinds.Conditional:
        return this._configuration.conditional;
      case CalculateKinds.PeriodDate:
        return this._configuration.datePeriod;
      case CalculateKinds.PeriodTime:
        return this._configuration.timePeriod;
    }
  }

  public readTextStyle(source: CalculateItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    if (source.shouldInputFree || (source.isFreeInputable && shouldInputFree)) {
      return isFocused
        ? this.toFreeInputTextStyle(source)
        : this.toTextStyle(source);
    } else if (source.value !== null && (source.value !== undefined)) {
      return this.toTextStyle(source);
    }
    return (source.calculateKind === CalculateKinds.Conditional)
      ? this.toObjectNameTextStyle(source)
      : this.toErrorTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
